import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import theme from '../theme'

// NOTE must NOT be functional component to allow `refs`

export class FormInput extends Component {
  blur() {
    this.target.blur()
  }
  focus() {
    this.target.focus()
  }
  render() {
    const { className, disabled, id, multiline, noedit, size, ...props } =
      this.props

    // NOTE return a different component for `noedit`
    if (noedit) return <InputNoedit {...this.props} />

    const { formFieldId, formLayout } = this.context

    props.id = id || formFieldId

    const setRef = (n) => (this.target = n)
    const StyledTag = multiline ? StyledTextarea : StyledInput

    return (
      <StyledTag
        ref={setRef}
        className={className}
        size={size}
        disabled={disabled}
        formLayout={formLayout}
        {...props}
      />
    )
  }
}

FormInput.propTypes = {
  multiline: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'small', 'large']),
  type: PropTypes.string
}
FormInput.defaultProps = {
  size: 'default',
  type: 'text'
}
FormInput.contextTypes = {
  formLayout: PropTypes.oneOf(['basic', 'horizontal', 'inline']),
  formFieldId: PropTypes.string
}

const StyledInput = styled.input`
  appearance: none;
  background-color: ${theme.input.background.default};
  background-image: none;
  border-color: ${theme.input.border.color.default};
  border-radius: ${theme.input.border.radius}px;
  border-style: solid;
  border-width: ${theme.input.border.width}px;
  box-shadow: ${theme.input.boxShadow};
  color: inherit;
  display: block;
  height: ${theme.input.height}px;
  line-height: ${theme.input.lineHeight};
  padding: 0 ${theme.input.paddingHorizontal};
  transition:
    border-color ease-in-out 0.15s,
    box-shadow ease-in-out 0.15s;
  width: 100%;

  &:hover {
    border-color: ${theme.input.border.color.hover};
    outline: 0;
  }

  &:focus {
    border-color: ${theme.input.border.color.focus};
    box-shadow: ${theme.input.boxShadowFocus};
    outline: 0;
  }

  ${(props) =>
    props.disabled &&
    `
    background-color: ${theme.input.background.disabled};
    pointer-events: none;
  `}

  ${(props) =>
    props.size === 'small' &&
    `
    font-size: ${theme.font.size.small};
  `}

  ${(props) =>
    props.size === 'large' &&
    `
    font-size: ${theme.font.size.large};
  `}
`

const StyledTextarea = styled.textarea`
  appearance: none;
  background-color: ${theme.input.background.default};
  background-image: none;
  border-color: ${theme.input.border.color.default};
  border-radius: ${theme.input.border.radius}px;
  border-style: solid;
  border-width: ${theme.input.border.width}px;
  box-shadow: ${theme.input.boxShadow};
  color: inherit;
  display: block;
  height: ${theme.input.height}px;
  line-height: ${theme.input.lineHeight};
  padding: 0 ${theme.input.paddingHorizontal};
  transition:
    border-color ease-in-out 0.15s,
    box-shadow ease-in-out 0.15s;
  width: 100%;

  &:hover {
    border-color: ${theme.input.border.color.hover};
    outline: 0;
  }

  &:focus {
    border-color: ${theme.input.border.color.focus};
    box-shadow: ${theme.input.boxShadowFocus};
    outline: 0;
  }

  ${(props) =>
    props.disabled &&
    `
    background-color: ${theme.input.background.disabled};
    pointer-events: none;
  `}

  ${(props) =>
    props.size === 'small' &&
    `
    font-size: ${theme.font.size.small};
  `}

  ${(props) =>
    props.size === 'large' &&
    `
    font-size: ${theme.font.size.large};
  `}
`

export default FormInput
